import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import bem from 'easy-bem';
import { IViewUtils } from '../../primer-sdk-web/src/checkout/ui/types';
import {
  CheckoutOptions,
  PrimerCheckout,
  SinglePaymentMethodCheckoutOptions,
  VaultManagerOptions,
} from '../../primer-sdk-web/src/types';
import { ClientContext } from '../../primer-sdk-web/src/core/ClientContextFactory';
import { SceneTransition } from '../../primer-sdk-web/src/checkout/SceneTransition';

interface ICheckoutContext {
  options:
    | CheckoutOptions
    | VaultManagerOptions
    | SinglePaymentMethodCheckoutOptions;
  checkout: PrimerCheckout;
  viewUtils: IViewUtils;
  context?: ClientContext;
  transitions: SceneTransition;
  className: typeof bem;
}

const CheckoutContext = createContext<ICheckoutContext | null>(null);

export const useCheckoutContext = () => {
  const context = useContext(CheckoutContext) as ICheckoutContext;
  return context;
};

export const { Provider } = CheckoutContext;
